import {createSlice} from '@reduxjs/toolkit';
import {respondToConsumer} from "../../api/auth/respondToConsumerAPI";

export const respondToQuoteSlice = createSlice({
    name: 'users',
    initialState: {
        request: false,
        messageTitle: '',
        message: '',
        outcome: 'pending',
    },
    reducers: {
        showError(state, action) {
            //console.log(action)
            state.request = false;
            state.outcome = 'fail';
            state.messageTitle = action.payload.title;
            state.message = action.payload.message;
        },
        showSuccess(state, action) {
            //console.log(action)
            state.request = false;
            state.outcome = 'success';
            state.messageTitle = action.payload.title;
            state.message = action.payload.message;
        },
        cancelError(state) {
            state.request = false;
            state.outcome = 'pending';
            state.message = '';
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(respondToConsumer.pending, (state, action) => {
                state.request = true;
            })
            .addCase(respondToConsumer.fulfilled, (state, action) => {
                state.request = false;
                state.outcome = 'success';
                state.message = '';
            })
            .addCase(respondToConsumer.rejected, (state, action) => {
                const { payload } = action;
                state.request = false;
                state.outcome = 'fail';
                state.messageTitle = 'Error';
                //@ts-ignore
                state.message = payload.message;
            })
    },
});

export const { cancelError, showError, showSuccess } = respondToQuoteSlice.actions

export default respondToQuoteSlice.reducer;